import { render, staticRenderFns } from "./AdminActivateAccountDialog.vue?vue&type=template&id=8b51fe84&scoped=true"
import script from "./AdminActivateAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminActivateAccountDialog.vue?vue&type=script&lang=js"
import style1 from "./AdminActivateAccountDialog.vue?vue&type=style&index=1&id=8b51fe84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b51fe84",
  null
  
)

export default component.exports